module.exports = __webpack_public_path__ + "media/images/game_icon/vi/AB3001-4493f3c6af5f5d6196a76b2e810d1452.png";